<template>
  <v-card class="white vetalfa-view" flat>
    <div class="vetalfa-global-header" ref="screenHeader">
      <v-row v-if="step != 0 || !!field" justify="start" class="ma-0 pa-0">
        <v-btn
          @click="back"
          large
          text
          class="ma-0 pa-0 primary--text text-none"
        >
          <v-icon color="#393a3a">{{ mdiChevronLeft }}</v-icon>
          <span>{{ _getLabel("BACK") }}</span>
        </v-btn>
      </v-row>
      <v-row
        align="center"
        justify="center"
        class="vetalfa-big-title ma-0 pa-0 mt-5"
      >
        <v-col cols="10">
          <p class="ma-0 pa-0 text-center">{{ stepTitle }}</p>
        </v-col>
      </v-row>
      <v-row align="start" justify="center" class="ma-0 pa-0 mt-2">
        <v-col class="ma-0 pa-0" cols="10">
          <p class="vetalfa-topic ma-0 pa-0">{{ stepTopic }}</p>
        </v-col>
      </v-row>
    </div>
    <div ref="screenContent">
      <v-row no-gutters justify="center" class="pt-4">
        <v-col
          v-show="step === 0"
          :cols="_isMobile() ? 12 : 8"
          class="ma-0 pa-0"
        >
          <algorithms :headerHeightOffset="headerHeightOffset"></algorithms>
          <v-row no-gutters class="white" style="height: 150px"></v-row>
        </v-col>
        <v-col
          :cols="_isMobile() ? 12 : 8"
          class="ma-0 pa-0 px-4"
          v-show="step === 1"
        >
          <v-row class="ma-0 pa-0" justify="center">
            <chip-group
              v-on:selectChip="selectVeterinaryStatus"
              :items="availableVeterinaryStatus"
            ></chip-group>
          </v-row>
          <v-row class="ma-0 pa-0 py-10" justify="center">
            <v-btn
              class="text-none primary px-8"
              rounded
              v-if="!!veterinaryStatus"
              @click="step++"
              >{{ _getLabel("CONTINUE") }}</v-btn
            >
          </v-row>
        </v-col>
        <v-col
          :cols="_isMobile() ? 12 : 8"
          class="ma-0 pa-0 px-4"
          v-show="step === 2"
        >
          <v-row
            v-if="veterinaryStatus !== 3"
            class="ma-0 pa-0"
            justify="center"
          >
            <v-combobox
              light
              hide-details
              dense
              class="mt-4"
              color="primary"
              outlined
              :items="veterinaryColleges"
              :placeholder="_getLabel('QUESTIONS_SCHOOL')"
              v-model="college"
              :menu-props="{ maxHeight: 164, top: true }"
              clearable
            ></v-combobox>
          </v-row>
          <v-row v-else class="ma-0 pa-0" justify="center">
            <v-text-field
              light
              hide-details
              dense
              color="primary"
              outlined
              :placeholder="_getLabel('QUESTIONS_OCUPATION')"
              v-model="ocupation"
              clearable
            ></v-text-field>
          </v-row>
          <v-row
            v-if="veterinaryStatus === 1"
            class="ma-0 pa-0 mt-4"
            justify="center"
          >
            <chip-group
              multiple
              v-on:selectChip="selectAcademicDegrees"
              :items="availableAcademicDegrees"
            ></chip-group>
          </v-row>
          <v-row
            v-if="veterinaryStatus === 2"
            class="ma-0 pa-0 mt-4"
            justify="center"
          >
            <v-select
              :items="completionYears"
              :placeholder="_getLabel('QUESTIONS_GRADUATION_YEAR')"
              light
              hide-details
              dense
              color="primary"
              outlined
              :v-menu="{ offsetY: true }"
              v-model="courseCompletion"
            ></v-select>
          </v-row>
          <v-row class="ma-0 pa-0 py-10" justify="center">
            <v-btn
              class="text-none primary px-8"
              rounded
              :disabled="!veterinaryStatus"
              @click="step++"
              >{{ _getLabel("CONTINUE") }}</v-btn
            >
          </v-row>
        </v-col>
        <v-col
          :cols="_isMobile() ? 12 : 8"
          class="ma-0 pa-0 px-4"
          v-show="step === 3"
        >
          <v-row align="center" justify="center" class="ma-0 pa-0">
            <chip-group
              multiple
              v-on:selectChip="selectInterests"
              :items="availableInterests"
            ></chip-group>
          </v-row>
          <v-row class="ma-0 pa-0 py-10" justify="center">
            <v-btn
              class="text-none primary px-8"
              rounded
              :disabled="!veterinaryStatus"
              @click="saveUserDataAsync(false)"
              >{{ _getLabel("QUESTIONS_CONFIRM") }}</v-btn
            >
          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import { mdiChevronLeft } from "@mdi/js";
import { mapActions, mapGetters, mapMutations } from "vuex";
import enums from "@/constants/enums.js";
import ChipGroup from "@/components/ChipGroup.vue";
import Algorithms from "@/algorithms/Algorithms.vue";
export default {
  name: "Registration",
  methods: {
    ...mapActions("general", [
      "saveUserData",
      "getVeterinaryColleges",
      "routeBack",
    ]),
    ...mapActions("algorithms", ["openAlgorithmsByModuleAndName"]),
    ...mapMutations("general", ["setVeterinaryColleges"]),
    ...mapMutations("algorithms", ["setModels", "setInputs"]),
    back() {
      if (
        (this.field === "questions" && this.step === 1) ||
        (!!this.field && this.step === 0)
      ) {
        return this.routeBack();
      }
      this.step--;
    },
    selectVeterinaryStatus(val) {
      if (typeof val !== "number") {
        this.veterinaryStatus = null;
        return;
      }
      this.veterinaryStatus = enums.VETERINARY_STATUS[val].value;
      this.step++;
    },
    selectInterests(val) {
      if (!val) {
        this.interests = [];
      } else {
        this.interests = val.map((v) => v + 1).sort((a, b) => a - b);
      }
    },
    selectAcademicDegrees(val) {
      if (!val) {
        this.academicDegrees = [];
      } else {
        this.academicDegrees = val.map((v) => v + 1).sort((a, b) => a - b);
      }
    },
    saveUserDataAsync: async function (skipQuestions = false) {
      let user = {};
      if (!skipQuestions) {
        user["questions"] = {
          ocupation: this.ocupation,
          interests: this.interests,
          college: this.college,
          courseCompletion: this.courseCompletion,
          veterinaryStatus: this.veterinaryStatus,
          academicDegrees: this.academicDegrees,
        };
      } else if (this.field === "crmv") {
        user["questions"] = {
          ...this.user.questions,
          veterinaryStatus: 1,
        };
      }
      this.saveUserData({ user, hasRedirect: !this.field, field: this.field });
    },
    selectCollege(selectedCollege) {
      this.college = selectedCollege;
    },
    setupScreenSizes() {
      this._setupScreenSizes(this);
      this.headerHeightOffset = this.$refs.screenHeader.offsetHeight;
    },
  },
  watch: {
    flowEndTrigger(val) {
      if (val) {
        if (!!this.user.questions) {
          this.saveUserDataAsync(true);
        } else {
          this.step++;
        }
      }
    },
    step() {
      this.setupScreenSizes();
    },
  },
  components: {
    "chip-group": ChipGroup,
    algorithms: Algorithms,
  },
  computed: {
    ...mapGetters("general", ["user", "veterinaryColleges"]),
    ...mapGetters("algorithms", ["flowEndTrigger", "getModels", "inputs"]),
    models: {
      get() {
        return this.getModels;
      },
      set(val) {
        this.setModels(val);
      },
    },
    field() {
      return this.$route.params.field;
    },
    completionYears() {
      const baseYear = new Date().getFullYear();
      let years = [];
      for (let i = 0; i < 15; i++) {
        years.push(baseYear + i);
      }
      return years;
    },
    availableInterests() {
      return enums.AREAS_OF_INTEREST.map((a) => a.description);
    },
    availableVeterinaryStatus() {
      return enums.VETERINARY_STATUS.map((v) => v.text);
    },
    availableAcademicDegrees() {
      return enums.ACADEMIC_DEGREES.map((v) => v.description);
    },
    stepTitle() {
      const { _getLabel, field, step } = this;
      return {
        0: _getLabel(
          !!field ? "QUESTIONS_FIRST_STEP_EDITION" : "QUESTIONS_FIRST_STEP"
        ),
        1: _getLabel("QUESTIONS_SECOND_STEP"),
        2: _getLabel("QUESTIONS_THIRD_STEP"),
        3: _getLabel("QUESTIONS_FOURTH_STEP"),
      }[step];
    },
    stepTopic() {
      const { _getLabel, field, step, veterinaryStatus } = this;
      return {
        0: _getLabel(
          !!field ? "QUESTIONS_FIRST_TOPIC_EDITION" : "QUESTIONS_FIRST_TOPIC"
        ),
        1: _getLabel("QUESTIONS_SECOND_TOPIC"),
        2: {
          1: _getLabel("QUESTIONS_PROFESSIONAL_TOPIC"),
          2: _getLabel("QUESTIONS_STUDENT_TOPIC"),
          3: _getLabel("QUESTIONS_OTHERS_TOPIC"),
        }[veterinaryStatus],
        3: _getLabel("QUESTIONS_FOURTH_TOPIC"),
      }[step];
    },
  },
  data() {
    return {
      step: 0,
      mdiChevronLeft,
      veterinaryStatus: null,
      academicDegrees: [],
      ocupation: "",
      interests: [],
      college: "",
      courseCompletion: null,
      headerHeightOffset: 0,
    };
  },
  created() {
    this.setInputs([]);
    const { field, user, openAlgorithmsByModuleAndName } = this;
    const hasNationality = !!user.cpf || !!user.nationality;
    if (!!field && field !== "questions") {
      openAlgorithmsByModuleAndName({
        module: "users",
        name: `${field}Algorithm`,
        children: [],
      });
    } else if (!user.birthday || !hasNationality || !user.displayName) {
      openAlgorithmsByModuleAndName({
        module: "users",
        name: "nationalityAlgorithm",
        children: ["displayNameAlgorithm", "birthdayAlgorithm"],
      });
    } else {
      this.step++;
    }
    this.getVeterinaryColleges();
  },
  mounted() {
    this.setupScreenSizes();
  },
};
</script>